import { render, staticRenderFns } from "./VistaRutas.vue?vue&type=template&id=36114542"
import script from "./VistaRutas.vue?vue&type=script&lang=js"
export * from "./VistaRutas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports